import React from "react";
import mapImg from "./../assets/img/worldMap.png";
import { mapPoints } from "../utils/data/mapPointsData";
import MapPoint from "./mapPoint";

const WorldMap = () => {
  return (
    <div>
      <div className="relative w-full border border-ink-14 bg-paper-pure p-4">
        <div className="relative w-full">
          <img
            src={mapImg}
            alt="World map"
            className="w-full h-auto object-contain grayscale opacity-90"
          />
          {mapPoints.map((point, index) => (
            <MapPoint
              key={index}
              pointPosition={point.pointPosition}
              pointColor={point.pointColor}
              pointText={point.pointText}
              pointBgColor={point.pointBgColor}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorldMap;
